export default {
  transporter: {
    avatar: 'TRANSPORTER_AVATAR',
    facade: 'TRANSPORTER_FACADE',
    certificate: 'TRANSPORTER_CERTIFICATE',
  },
  shipper: {
    avatar: 'SHIPPER_AVATAR',
    facade: 'SHIPPER_FACADE',
  },
  driver: {
    avatar: 'DRIVER_AVATAR',
    document: 'DRIVER_DOCUMENT',
  },
  shipping: {
    receipt: 'SHIPPING_RECEIPT',
    occurrence: 'OCCURRENCE_IMAGE',
    document: 'SHIPPING_DOCUMENT',
  },
  vehicle: {
    image: 'VEHICLE_IMAGE',
  },
  user: {
    azship: 'AZSHIP_USER_AVATAR',
    transporter: 'TRANSPORTER_USER_AVATAR',
    shipper: 'SHIPPER_USER_AVATAR',
  },
}
